/**
 * gh-product-extras.js
 * Green Heaven — product hero extras:
 *   1. Countdown timer  (.gh-countdown-band)
 *   2. Reviews carousel (.gh-rev-block)
 *
 * Settings are read from data attributes on .gh-countdown-band:
 *   data-cutoff="14:00"        — cutoff time (24h HH:MM, Copenhagen local)
 *   data-active-days="1,2,3,4,5" — active weekdays (JS: 0=Sun,1=Mon…6=Sat)
 *
 * Reviews metafield: product.metafields.custom.reviews
 */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     1. COUNTDOWN TIMER
  ────────────────────────────────────────────── */
  function initCountdown() {
    const band = document.querySelector('.gh-countdown-band');
    if (!band) return;

    const timerEl = document.getElementById('gh-timer-val');
    if (!timerEl) return;

    const cutoffStr = band.dataset.cutoff || '14:00';
    const activeDaysStr = band.dataset.activeDays || '1,2,3,4,5';
    const activeDays = activeDaysStr.split(',').map(Number);

    const [cutoffH, cutoffM] = cutoffStr.split(':').map(Number);

    function msUntilCutoff() {
      // Work in Copenhagen local time (Europe/Copenhagen, UTC+1/+2)
      const now = new Date();
      // Create a date in Copenhagen timezone to get correct local day/time
      const copenhagenStr = now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' });
      const cph = new Date(copenhagenStr);

      let dayOfWeek = cph.getDay(); // 0=Sun
      let h = cph.getHours();
      let m = cph.getMinutes();
      let s = cph.getSeconds();

      // Seconds elapsed today in Copenhagen
      const secsToday = h * 3600 + m * 60 + s;
      const cutoffSecs = cutoffH * 3600 + cutoffM * 60;

      // Find the next active day with remaining time
      for (let offset = 0; offset < 8; offset++) {
        const checkDay = (dayOfWeek + offset) % 7;
        if (!activeDays.includes(checkDay)) continue;

        if (offset === 0) {
          // Today — is cutoff still in the future?
          if (secsToday < cutoffSecs) {
            return (cutoffSecs - secsToday) * 1000;
          }
          // Passed cutoff today — move to next active day
          continue;
        } else {
          // A future active day — full cutoff time from start of that day
          const msTillMidnight = (86400 - secsToday) * 1000;
          const msExtraDays = (offset - 1) * 86400 * 1000;
          return msTillMidnight + msExtraDays + cutoffSecs * 1000;
        }
      }
      return null; // no active day found in next 7 days
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const ms = msUntilCutoff();
      if (ms === null || ms < 0) {
        timerEl.textContent = 'i morgen';
        return;
      }
      const totalSec = Math.floor(ms / 1000);
      const h = Math.floor(totalSec / 3600);
      const min = Math.floor((totalSec % 3600) / 60);
      const sec = totalSec % 60;
      timerEl.innerHTML =
        '<span class="gh-t-num">' + pad(h) + '</span>' +
        '<span class="gh-t-unit">t</span> ' +
        '<span class="gh-t-num">' + pad(min) + '</span>' +
        '<span class="gh-t-unit">m</span> ' +
        '<span class="gh-t-num">' + pad(sec) + '</span>' +
        '<span class="gh-t-unit">s</span>';
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ──────────────────────────────────────────────
     2. REVIEWS CAROUSEL
  ────────────────────────────────────────────── */
  function initReviewsCarousel() {
    // Support multiple product-info blocks on the same page
    document.querySelectorAll('.gh-rev-block').forEach(function (block) {
      const inner = block.querySelector('.gh-rev-inner');
      const dotsEl = block.querySelector('.gh-rev-dots');
      if (!inner || !dotsEl) return;

      const cards = Array.from(inner.querySelectorAll('.gh-rev-card'));
      if (cards.length <= 1) return;

      let current = 0;

      // Build dots
      cards.forEach(function (_, i) {
        const dot = document.createElement('button');
        dot.setAttribute('aria-label', 'Gå til anmeldelse ' + (i + 1));
        dot.className = 'gh-rev-dot' + (i === 0 ? ' gh-rev-dot--active' : '');
        dot.addEventListener('click', function () {
          goTo(i);
        });
        dotsEl.appendChild(dot);
      });

      function goTo(idx) {
        current = (idx + cards.length) % cards.length;
        inner.style.transform = 'translateX(-' + (current * 100) + '%)';
        dotsEl.querySelectorAll('.gh-rev-dot').forEach(function (d, i) {
          d.className = 'gh-rev-dot' + (i === current ? ' gh-rev-dot--active' : '');
        });
      }

      // Auto-advance every 5 seconds
      let autoTimer = setInterval(function () {
        goTo(current + 1);
      }, 5000);

      // Pause on hover
      inner.addEventListener('mouseenter', function () {
        clearInterval(autoTimer);
      });
      inner.addEventListener('mouseleave', function () {
        autoTimer = setInterval(function () {
          goTo(current + 1);
        }, 5000);
      });

      // Touch swipe
      let touchStartX = 0;
      inner.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      inner.addEventListener('touchend', function (e) {
        const dx = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(dx) > 40) {
          goTo(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    });
  }

  /* ──────────────────────────────────────────────
     3. PRICE ROW  (main · compare-at · per-gram · −X%)
     Target order, left to right:
        2.200,00 kr   3.500,00 kr   44,00 kr/gram   [−38%]

     The per-gram pill itself is rendered in Liquid
     (snippets/per-gram-price.liquid via snippets/price.liquid), so it is
     re-rendered automatically by the theme's Section Rendering API on every
     variant change — no JSON map or manual formatting needed.

     This function only (a) synthesises the compare-at price + discount % for
     products that have no real compare_at_price, using the same integer math
     as the variant pill badges so the percentages match, and (b) guarantees
     the left-to-right order by grouping compare / pill / badge into one
     wrapper appended to whichever price container is visible.
  ────────────────────────────────────────────── */
  function initPriceRow() {
    var priceBox = document.querySelector('.product__block--price [id^="price-"], [id^="price-"][role="status"]');
    if (!priceBox) return;

    // Scoped styles, injected once
    if (!document.getElementById('gh-price-discount-style')) {
      var st = document.createElement('style');
      st.id = 'gh-price-discount-style';
      st.textContent =
        '.gh-js-price-extra{display:inline-flex;align-items:center;gap:1rem;margin-inline-start:1rem;white-space:nowrap;}' +
        '.gh-js-compare{color:var(--color-foreground-lighten-60,#8d978f);font-size:var(--font-body-size,1.4rem);font-weight:var(--font-body-weight,400);text-decoration:line-through;}' +
        '.gh-js-discount{font-family:"Outfit",var(--font-heading-family,sans-serif);font-weight:600;font-size:1.6rem;color:#c2843e;letter-spacing:-0.018rem;line-height:normal;}';
      document.head.appendChild(st);
    }

    function gramsOf(str) {
      if (!str) return 0;
      var m = String(str).toLowerCase().replace(/\s+/g, '').match(/(\d+(?:[.,]\d+)?)g(?:\b|$|\/)/);
      return m ? parseFloat(m[1].replace(',', '.')) : 0;
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat('da-DK', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100) + ' kr';
      } catch (e) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
      }
    }

    var productPromise = null;
    function getProduct() {
      if (!productPromise) {
        var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
        var m = path.match(/(.*\/products\/[^\/]+)/);
        productPromise = m
          ? fetch(m[1] + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; })
          : Promise.resolve(null);
      }
      return productPromise;
    }

    function currentVariant(product) {
      var input = document.querySelector('form[id^="product-form-"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
      var id = input ? parseInt(input.value, 10) : 0;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) { v = product.variants[i]; break; }
      }
      return v || product.variants[0];
    }

    // Same integer math as the variant pill badges, so percentages match
    function compute(product, variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var p = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        return p > 0 ? { compare: variant.compare_at_price, pct: p, real: true } : null;
      }
      var g = gramsOf(variant.option1) || gramsOf(variant.title);
      if (!g) return null;
      var base = 0;
      product.variants.forEach(function (v) {
        var vg = gramsOf(v.option1) || gramsOf(v.title);
        if (vg > 0) {
          var ppg = Math.floor((v.price * 100) / vg);
          if (ppg > base) base = ppg;
        }
      });
      if (!base) return null;
      var compare = Math.round((base * g) / 100);
      if (compare <= variant.price) return null;
      var thisPpg = Math.floor((variant.price * 100) / g);
      var pct = 100 - Math.floor((thisPpg * 100) / base);
      return pct > 0 ? { compare: compare, pct: pct, real: false } : null;
    }

    function apply() {
      getProduct().then(function (product) {
        var priceEl = priceBox.querySelector('.f-price');
        if (!priceEl) return;

        // The theme hides .f-price__regular when a real compare_at_price exists
        // and shows .f-price__sale instead — target whichever one is visible.
        var onSale = priceEl.classList.contains('f-price--on-sale');
        var container = onSale
          ? priceEl.querySelector('.f-price__sale')
          : priceEl.querySelector('.f-price__regular');
        if (!container) return;

        // Liquid-rendered per-gram pill (may be absent: no gram data)
        var pill = priceEl.querySelector('.per-gram-badge');

        var info = null;
        if (product && product.variants && product.variants.length) {
          info = compute(product, currentVariant(product));
        }

        // When the theme already prints a real strikethrough, don't duplicate it.
        var showCompare = !!info && !onSale;
        var showPct = !!info;

        var state = [
          showCompare ? money(info.compare) : '',
          showPct ? info.pct : '',
          pill ? pill.textContent.trim() : '',
          onSale ? 'sale' : 'regular'
        ].join('|');

        var existing = priceEl.querySelector('.gh-js-price-extra');
        if (existing && existing.getAttribute('data-gh-state') === state && existing.parentNode === container) {
          return; // already correct — no DOM writes, no observer loop
        }

        if (existing) existing.remove(); // `pill` reference survives removal
        if (!showCompare && !showPct && !pill) return;

        var wrap = document.createElement('span');
        wrap.className = 'gh-js-price-extra';
        wrap.setAttribute('data-gh-state', state);

        if (showCompare) {
          var cmp = document.createElement('s');
          cmp.className = 'gh-js-compare';
          cmp.textContent = money(info.compare);
          wrap.appendChild(cmp);
        }
        if (pill) wrap.appendChild(pill); // moved, never recreated
        if (showPct) {
          var pctEl = document.createElement('span');
          pctEl.className = 'gh-js-discount';
          pctEl.textContent = '−' + info.pct + '%';
          wrap.appendChild(pctEl);
        }

        container.appendChild(wrap);
      });
    }

    // Re-apply whenever the theme re-renders the price box (variant change)
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; apply(); }, 50);
    }).observe(priceBox, { childList: true, subtree: true });

    // Backup trigger: variant option changes
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(apply, 350);
      }
    });

    apply();
  }

  /* ──────────────────────────────────────────────
     INIT
  ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCountdown();
      initReviewsCarousel();
      initPriceRow();
    });
  } else {
    initCountdown();
    initReviewsCarousel();
    initPriceRow();
  }
})();